
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Action } from ".";
import { Contact } from "../contacts/models/contact.model";
import { AppActionTypes } from "./app";

export class AllGalContactsActionTypes extends AppActionTypes {
  // load All Gal Contacts
  static LOAD_ALL_GAL_CONTACTS = "[Contacts] Load All Gal Contacts";
  static LOAD_ALL_GAL_CONTACTS_FAIL = "[Contacts] Load All Gal Contacts Fail";
  static LOAD_ALL_GAL_CONTACTS_SUCCESS = "[Contacts] Load All Gal Contacts Success";
}

export class LoadAllGalContacts implements Action {
  readonly type = AllGalContactsActionTypes.LOAD_ALL_GAL_CONTACTS;
}

export class LoadAllGalContactsFail implements Action {
  readonly type = AllGalContactsActionTypes.LOAD_ALL_GAL_CONTACTS_FAIL;
}

export class LoadAllGalContactsSuccess implements Action {
  readonly type = AllGalContactsActionTypes.LOAD_ALL_GAL_CONTACTS_SUCCESS;
  constructor(public payload: { contact: Contact[] }) { }
}
